import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Util} from "../../controller/Util";

const FIELD_VALUE_ACESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TextAreaComponent),
    multi: true
}

@Component({
    selector: 'app-text-area',
    templateUrl: './text-area.component.html',
    providers: [FIELD_VALUE_ACESSOR],
    standalone: false
})
export class TextAreaComponent implements ControlValueAccessor {

    @Input() label: string = '';
    @Input() placeholder = '';
    @Input() id: string = Util.randomId();
    @Input() isReadOnly = false;
    @Input() rows = 5;
    @Input() maxLength: number | null = null;
    @Input() validacao: AbortController | FormControl | any = new FormControl;
    @Input() tentativa = false;

    @Output() onBlur = new EventEmitter<any>()
    @Output() onKeypress = new EventEmitter<any>()

    private innerValue: any;
    isDisabledByForm = false;

    get value() {
        return this.innerValue;
    }

    set value(v: any) {
        if(v !== this.innerValue) {
            this.innerValue = v;
            this.onChange(v)
        }
    }

    onChange: (_: any) => void = () => {}
    onTouched: (_: any) => void = () => {}

    get campoInvalido() {
        return this.validacao !== undefined && this.validacao.invalid && this.tentativa;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabledByForm = isDisabled;
    }

    writeValue(v: any): void {
        this.value = v;
    }
}
